import React from 'react'
import Link from 'gatsby-link'
import Home from '../components/home'

const IndexPage = ({ data }) => {
  return <Home headerImage={data.headerImage} />
}

export default IndexPage

export const pageQuery = graphql`
  query HomeImageQuery {
    headerImage: imageSharp(id: { regex: "/home/" }) {
      sizes(maxWidth: 1240) {
        ...GatsbyImageSharpSizes
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js